"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var browsers_directives_1 = require("./browsers-directives");
exports.IsChrome = browsers_directives_1.IsChrome;
exports.IsFirefox = browsers_directives_1.IsFirefox;
exports.IsSafari = browsers_directives_1.IsSafari;
exports.IsOpera = browsers_directives_1.IsOpera;
exports.IsIE = browsers_directives_1.IsIE;
exports.IsIE9 = browsers_directives_1.IsIE9;
exports.IsIE10 = browsers_directives_1.IsIE10;
exports.IsIE11 = browsers_directives_1.IsIE11;
exports.IsIE12 = browsers_directives_1.IsIE12;
exports.ShowItBrowser = browsers_directives_1.ShowItBrowser;
exports.HideItBrowser = browsers_directives_1.HideItBrowser;
exports.ShowIEVersion = browsers_directives_1.ShowIEVersion;
exports.HideIEVersion = browsers_directives_1.HideIEVersion;
exports.IeInfo = browsers_directives_1.IeInfo;
exports.BrowserInfo = browsers_directives_1.BrowserInfo;
exports.BROWSER_DIRECTIVES = [
    browsers_directives_1.IsChrome,
    browsers_directives_1.IsFirefox,
    browsers_directives_1.IsSafari,
    browsers_directives_1.IsOpera,
    browsers_directives_1.IsIE,
    browsers_directives_1.IsIE9,
    browsers_directives_1.IsIE10,
    browsers_directives_1.IsIE11,
    browsers_directives_1.IsIE12,
    browsers_directives_1.ShowItBrowser,
    browsers_directives_1.HideItBrowser,
    browsers_directives_1.ShowIEVersion,
    browsers_directives_1.HideIEVersion,
    browsers_directives_1.IeInfo,
    browsers_directives_1.BrowserInfo
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src4078178155/src/~/ng2-responsive/browsers/index.js
// module id = M6+q
// module chunks = 6